import { useAtom } from '@reatom/npm-react'
import React from 'react'

import { FavoriteWalletStar } from '../favorite-wallet-star/favorite-wallet-star'

import { WalletShort } from './wallet-short'

import type { WalletModel } from '../../atoms'
import type { ClassNameProps } from '@root/shared/react'

type Size = 'md' | 'sm' | 'xs'

type Props = {
  wallet: WalletModel
  size?: Size
  colorOverride?: string
  withFavorite?: boolean
} & ClassNameProps &
  Omit<React.ComponentPropsWithoutRef<'div'>, 'children' | 'color'>

export const WalletModelShort: React.FC<Props> = ({
  wallet,
  size = 'md',
  className,
  colorOverride,
  withFavorite = false,
  ...rest
}) => {
  const [name] = useAtom(wallet.name)
  const [color] = useAtom(wallet.color)

  return (
    <WalletShort
      className={className}
      name={name}
      color={colorOverride ?? color}
      size={size}
      favoriteSlot={
        withFavorite ? (
          <FavoriteWalletStar wallet={wallet} size={ICON_SIZE_MAP[size]} />
        ) : undefined
      }
      {...rest}
    />
  )
}

const ICON_SIZE_MAP: Record<Size, number> = {
  xs: 8,
  sm: 10,
  md: 16,
}
